export const STORE_CATEGORIES = 'STORE_CATEGORIES';

export const STORE_EVENTS = 'STORE_EVENTS';

export const STORE_ALBUMS = 'STORE_ALBUMS';

export const STORE_PRODUCTS = 'STORE_PRODUCTS';

export const STORE_SLIDERS = 'STORE_SLIDERS';